import { useRouteContext } from "@tanstack/react-router";
import { JobActions, useJobDefinition } from "./-job-definitions-context";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useTableRefresh } from "@/components/custom/data-table/data-table-context";
import { CommonQueryOptions } from "@/lib/utils";

import { showActionErrorToast } from "@/state/error-toast";

export function useScheduledJob() {
  const jobDefinition = useJobDefinition();
  const root = `${jobDefinition.root}/schedule/$scheduledJobId` as const;
  const { scheduledJobId, scheduledJobQuery: scheduledJobQuery_ } =
    useRouteContext({
      from: root as `/dashboard/jobs/video-upload/schedule/$scheduledJobId`,
    });
  const scheduledJobQuery = scheduledJobQuery_ as ReturnType<
    JobActions["getScheduledJob"]["asQueryOptions"]
  >;
  const scheduledJobResult = useQuery(
    scheduledJobQuery as CommonQueryOptions<typeof scheduledJobQuery>,
  );
  const queryClient = useQueryClient();
  const tableRefresh = useTableRefresh();
  const refresh = (options?: { propagate?: boolean }) => {
    if (options?.propagate) {
      tableRefresh();
    }
    queryClient.invalidateQueries({ queryKey: scheduledJobQuery.queryKey });
  };
  const edit = useMutation({
    ...jobDefinition.actions.updateSchedule
      .assign({ id: scheduledJobId, partial: true })
      .asMutationOptions(),
    onSuccess: () => refresh({ propagate: true }),
    onError: (err) => showActionErrorToast(err),
  });
  return {
    root,
    scheduledJobResult,
    scheduledJobId,
    scheduledJobQuery,
    refresh,
    edit,
  };
}

export function useScheduledJobId() {
  const jobDefinition = useJobDefinition();
  const root = `${jobDefinition.root}/schedule/$scheduledJobId` as const;
  const { scheduledJobId } = useRouteContext({
    from: root as `/dashboard/jobs/video-upload/schedule/$scheduledJobId`,
  });
  return scheduledJobId;
}
